import envConfig from '@nile/home/src/Config/env';
import { COMMON_CONSTANTS, fetchApi, getCookieValue } from '@nile/components';
import { cloneDeep, head, isEmpty, omit } from 'lodash';
import { EventEmitter } from '@nile/components';
import {
  IS_CHAT_ROUTE,
  IS_SYSTEMTRAY_ROUTE
} from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import { loggerInfo } from '@nile/home/src/coralogixRUM';

let broadcastChannel;
let reconnectLock = false;
let webReconnectLock = false;
let reconnectTimeout = null;
let webReconnectTimeout = null;

const RECONNECT_DELAY = 5000;

if (BroadcastChannel) {
  broadcastChannel = new BroadcastChannel('SuperShare');
}
let timeInterval;

let queueMessages = [];

let agentHeaders = {};

let ping = false;
let pingTimer;

let reconnectTimer;
let reconnectCount = 0;

let count = 0;
let setSocketError = {};

let headRequestTimer;

var networkDisconnect = false;

export const checkPingPongHeadRequest = () => {
  if (!headRequestTimer) {
    headRequestTimer = setInterval(() => {
      var xhr = new XMLHttpRequest();
      var file = 'https://assets.superops.ai/workers/sharedWorker.js';
      var randomNum = Math.round(Math.random() * 10000);
      xhr.open('HEAD', file + '?rand=' + randomNum, true);
      xhr.send();
      xhr.addEventListener('readystatechange', processRequest, false);
      function processRequest(e) {
        if (xhr.readyState == 4) {
          if (xhr.status >= 200 && xhr.status < 304) {
            if (networkDisconnect) {
              window.networkDisconnect = false;
              networkDisconnect = false;
              if (IS_CHAT_ROUTE) {
                connectAgentUserSocket({ headers: agentHeaders });
                // if (window.logger) {
                //   logger.info(
                //     'check socket status-->',
                //     xhr?.status,
                //     agentProperties
                //   );
                //   logger.flush();
                // }

                loggerInfo('check socket status-->', {
                  status: xhr?.status,
                  agentProperties
                });
              }
            }
          } else {
            window.networkDisconnect = true;
            networkDisconnect = true;
          }
        }
      }
    }, 30000);
  }
};

const checkForPong = () => {
  if (!ping) {
    return;
  } else {
    broadcastChannel.postMessage(
      JSON.stringify({
        name: 'close',
        connectionId: ['nile', 'agentsocket']
      })
    );
  }
};

const initateHeartBeat = () => {
  if (timeInterval) clearInterval(timeInterval);
  timeInterval = setInterval(() => {
    ping = true;
    if (pingTimer) clearTimeout(pingTimer);
    pingTimer = setTimeout(() => {
      checkForPong();
    }, 10000);
    broadcastChannel.postMessage(
      JSON.stringify({
        name: 'wsdata',
        data: {
          context: 'heartbeat',
          action: {
            name: 'heartbeat'
          }
        }
      })
    );
  }, 420000);
};

const connectSocket = async () => {
  const appCsrf = getCookieValue('app-csrf');
  if (isEmpty(appCsrf)) {
    return;
  }
  const myHeaders = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': appCsrf,
    isAutoAPIReq: true // This will whitelist this api from tracking user activity that will differentiate the automated requests
  };

  const graphql = JSON.stringify({
    variables: {},
    query: '{\n  populateUserTerminalWssToken\n}\n'
  });
  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    credentials: 'include',
    body: graphql
  };

  fetchApi(envConfig.accountsGateway, requestOptions)
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      return false;
    })
    .then((response) => {
      if (response) {
        broadcastChannel.postMessage(
          JSON.stringify({
            name: 'init',
            action: {
              name: 'connect',
              data: {
                url: `${localStorage.getItem('wssSocketUrl')}?reqType=client`,
                token: response?.data?.populateUserTerminalWssToken,
                apiURL:
                  localStorage?.getItem('apiDomain') +
                  envConfig.accountsGateway,
                cstoken: appCsrf
              }
            }
          })
        );
      }
    })
    .catch((error) => console.log('socket error', error));
};

function reconnectAgentUserSocket(agentHeaders) {
  const scheduleReconnect = () => {
    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
    if (reconnectCount < 5) {
      reconnectTimer = setTimeout(() => {
        connectAgentUserSocket({ headers: agentHeaders });
        reconnectCount++;
        scheduleReconnect(); // Schedule the next reconnect
      }, 60000);
    } else {
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
        reconnectTimer = null;
      }
    }
  };

  scheduleReconnect();
}

const connectAgentUserSocket = ({ headers }) => {
  const agentProperties = JSON.parse(sessionStorage.getItem('agentProperties'));

  const headerFromStorage = {
    'asset-id': agentProperties?.AssetId,
    'asset-token': agentProperties?.AssetToken,
    'app-acc': agentProperties?.AppAcc,
    reqType: 'assetUser',
    userId: agentProperties?.UserId,
    userName: agentProperties?.UserLoginName
  };

  const requestOptions = {
    method: 'POST',
    headers: headers || headerFromStorage
  };

  agentHeaders = cloneDeep(headers) || headerFromStorage;

  if (agentHeaders?.['asset-token'] || agentHeaders?.['app-acc']) {
    fetchApi('/rmm-web/rmmagent/assetUserSession', requestOptions)
      .then((res) => {
        if (res.ok) {
          reconnectCount = 0;
          if (reconnectTimer) {
            clearTimeout(reconnectTimer);
            reconnectTimer = null;
          }
          return res?.text();
        } else {
          if (!reconnectTimer) {
            // if (window.logger) {
            //   logger.info(
            //     'Asset user session failed to connect-->',
            //     agentProperties
            //   );
            //   logger.flush();
            // }

            loggerInfo('Asset user session failed to connect', agentProperties);
            reconnectAgentUserSocket(agentHeaders);
          }
        }
      })
      .then((response) => {
        if (response) {
          if (reconnectTimer) {
            clearTimeout(reconnectTimer);
            reconnectTimer = null;
          }
          const websocketUrl = `${localStorage.getItem('wssSocketUrl')}`;
          const url = new URL(websocketUrl);
          url.search = new URLSearchParams({
            ...omit(agentHeaders, ['asset-token']),
            token: response
          });

          broadcastChannel.postMessage(
            JSON.stringify({
              name: 'init',
              action: {
                name: 'agentconnect',
                data: {
                  connectionId: 'agentsocket',
                  url: url
                }
              }
            })
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    // if (window.logger) {
    //   logger.info(
    //     'Asset user websocket token generation failed due to empty payload',
    //     agentProperties
    //   );
    //   logger.flush();
    // }

    loggerInfo(
      'Asset user websocket token generation failed due to empty payload',
      agentProperties
    );
  }
};

const autoReconnectSession = (message) => {
  const data = JSON.parse(message.data);
  const { state, type } = data;

  const cstoken = getCookieValue('app-csrf');

  if (type === 'WSState') {
    if (!webReconnectLock) {
      if (cstoken) {
        if (isEmpty(setSocketError)) {
          if (timeInterval) {
            clearInterval(timeInterval);
          }
          if (pingTimer) clearTimeout(pingTimer);
          // Set the lock to prevent further reconnects within the RECONNECT_DELAY period
          webReconnectLock = true;
          if (webReconnectTimeout) {
            clearTimeout(webReconnectTimeout);
            webReconnectTimeout = null;
          }
          webReconnectTimeout = setTimeout(() => {
            webReconnectLock = false; // Unlock after the delay
          }, RECONNECT_DELAY);
          connectSocket();
          // if (window.logger) {
          //   logger.info('websocket count check--->', {
          //     count: count,
          //     appVersion: COMMON_CONSTANTS.APP_VERSION
          //   });
          //   logger.flush();
          // }

          loggerInfo('websocket count check--->', {
            count: count,
            appVersion: COMMON_CONSTANTS.APP_VERSION
          });
        } else if (state === 5) {
          setSocketError = data;
          // Set the lock to prevent further reconnects within the RECONNECT_DELAY period
          webReconnectLock = true;
          if (webReconnectTimeout) {
            clearTimeout(webReconnectTimeout);
            webReconnectTimeout = null;
          }
          webReconnectTimeout = setTimeout(() => {
            webReconnectLock = false; // Unlock after the delay
          }, RECONNECT_DELAY);
          // if (window.logger) {
          //   logger.info('websocket state--->', data);
          //   logger.flush();
          // }

          loggerInfo('websocket state--->', data);
        }
      } else {
        count = 99;
        setSocketError = {};
      }
    } else {
      console.log('Reconnect attempt ignored due to lock');
    }
  }
};

const autoReconnectAgentSession = (message) => {
  const data = JSON.parse(message.data);
  const { state, type } = data;
  if (type === 'WSState') {
    if (isEmpty(setSocketError) && state === 3) {
      if (timeInterval) {
        clearInterval(timeInterval);
      }
      if (pingTimer) clearTimeout(pingTimer);
      // if (window.logger) {
      //   logger.info(
      //     'connect Agent User Socket check infinite call',
      //     reconnectCount,
      //     agentProperties
      //   );
      //   logger.flush();

      // }
      loggerInfo('connect Agent User Socket check infinite call', {
        reconnectCount,
        agentProperties
      });
      connectAgentUserSocket({ headers: agentHeaders });
    } else if (state === 5) {
      setSocketError = data;
      // if (window.logger) {
      //   logger.info('agentwebsocket', data);
      //   logger.flush();

      // }
      loggerInfo('agentwebsocket', data);
    }
    reconnectLock = true;
    if (reconnectTimeout) {
      clearTimeout(reconnectTimeout);
      reconnectTimeout = null;
    }
    reconnectTimeout = setTimeout(() => {
      reconnectLock = false; // Unlock after the delay
    }, RECONNECT_DELAY);
  }
};

const pullQueueMessages = () => {
  if (queueMessages.length) {
    queueMessages.map((el, idx) => {
      broadcastChannel.postMessage(
        JSON.stringify({
          name: 'wsdata',
          data: el.data
        })
      );
    });
    queueMessages = [];
  }
};

const pushMessageToQueue = (data) => {
  if (queueMessages.length === 0) {
    queueMessages.push(data);
  } else {
    const idExist = queueMessages.findIndex(
      (el) => el?.data?.windowsId === data.data.windowsId
    );
    if (idExist === -1) {
      queueMessages.push(data);
    } else {
      queueMessages.splice(idExist, 1, data);
    }
  }
};

const cleanup = () => {
  // Clear all intervals
  if (headRequestTimer) {
    clearInterval(headRequestTimer);
    headRequestTimer = null;
  }
  if (timeInterval) {
    clearInterval(timeInterval);
    timeInterval = null;
  }

  // Clear all timeouts
  if (pingTimer) {
    clearTimeout(pingTimer);
    pingTimer = null;
  }
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
  if (reconnectTimeout) {
    clearTimeout(reconnectTimeout);
    reconnectTimeout = null;
  }
};

broadcastChannel.onmessage = (event) => {
  const agentProperties = JSON.parse(sessionStorage.getItem('agentProperties'));
  const data = JSON.parse(event.data);
  const { state, name, connectionId, body } = data;

  if (body === 'PONG') {
    ping = false;
    clearTimeout(pingTimer);
  }
  if (name && name === 'close') {
    count = 0;
    cleanup(); // Add cleanup when socket closes
  }
  if (name && name === 'wsdata' && count !== 0) {
    count = 0;
  }
  if (state === 1 && !timeInterval) {
    initateHeartBeat();
  }
  if (state === 1 && queueMessages.length) {
    pullQueueMessages();
  }
  if (queueMessages.length < 10 && name === 'wsdata') {
    pushMessageToQueue(data);
  }

  if (state === 3) {
    if (agentProperties && IS_CHAT_ROUTE) {
      if (!reconnectLock) {
        autoReconnectAgentSession(event);
      } else {
        console.log('Reconnect agent attempt ignored due to lock');
      }
    } else if (!IS_SYSTEMTRAY_ROUTE) {
      if (!webReconnectLock) {
        autoReconnectSession(event);
      } else {
        console.log('Reconnect attempt ignored due to lock');
      }
    }
  }
};

export {
  initateHeartBeat,
  connectSocket,
  autoReconnectSession,
  connectAgentUserSocket
};
